import { render, staticRenderFns } from "./PromotorSearchComponent.vue?vue&type=template&id=3164e04a&scoped=true&"
import script from "./PromotorSearchComponent.vue?vue&type=script&lang=ts&"
export * from "./PromotorSearchComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PromotorSearchComponent.vue?vue&type=style&index=0&id=3164e04a&lang=scss&scoped=true&"
import style1 from "./PromotorSearchComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164e04a",
  null
  
)

export default component.exports